import React, {
  forwardRef,
  type MouseEvent,
  type KeyboardEvent,
  type ChangeEvent,
  type FocusEvent,
} from "react";
import cx from "classnames";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import { Icon } from "../../Icon/Icon";

type InputComponentProps = {
  min: number;
  max: number;
  value: number;
  disabled: boolean;
  classNames: string;
  onMouseEnter?: (e: MouseEvent<HTMLDivElement>) => void;
  handleMinusClick: (e: MouseEvent<HTMLDivElement>) => void;
  handlePlusClick: (e: MouseEvent<HTMLDivElement>) => void;
  onEnterPressed?: (e: KeyboardEvent<HTMLDivElement>) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  testId?: string;
};

export const InputComponent = forwardRef<HTMLDivElement, InputComponentProps>(
  (
    {
      min,
      max,
      value,
      disabled = false,
      classNames,
      onMouseEnter = () => {},
      handleMinusClick,
      handlePlusClick,
      handleChange = () => {},
      onBlur = () => {},
      onEnterPressed = () => {},
      testId,
    },
    ref,
  ) => (
    <div ref={ref} className={classNames} onMouseEnter={onMouseEnter}>
      <InputGroup className="d-flex flex-nowrap">
        <InputGroupText
          className="bg-gray-100 p-1"
          onClick={handleMinusClick}
          onMouseDown={(e) => e.preventDefault()}
          data-testid="-"
        >
          <Icon
            iconName="minus-regular"
            className={cx("icon-12", {
              "cursor-not-allowed opacity-20 disabled":
                +min >= value || disabled,
            })}
          />
        </InputGroupText>
        <Input
          className={cx("rounded-0 text-center appearance-none fs-md p-0")}
          style={{ width: "40px", opacity: disabled ? 0.5 : 1 }}
          bsSize="sm"
          type="number"
          min={0}
          onChange={handleChange}
          disabled={disabled}
          value={value}
          data-testid={testId}
          onKeyDown={(e) => e.key === "Enter" && onEnterPressed(e)}
          onBlur={onBlur}
        />
        <InputGroupText
          className="bg-gray-100 p-1"
          onClick={handlePlusClick}
          onMouseDown={(e) => e.preventDefault()}
          data-testid="+"
        >
          <Icon
            iconName="plus-regular"
            className={cx("icon-12", {
              "cursor-not-allowed opacity-20 disabled":
                +max === value || disabled,
            })}
          />
        </InputGroupText>
      </InputGroup>
    </div>
  ),
);
